import normalize from 'json-api-normalizer';
import { JsonApiObject } from 'json-api-normalizer';

import { Testimonial, TestimonialJSONAPIResponse } from './types';

export function serializeTestimonialFromAPI(json: TestimonialJSONAPIResponse): Testimonial {
    const { testimonial } = normalize<{
        testimonial: Record<string, JsonApiObject>;
    }>(json);
    const dossierId = json.data.id;

    return testimonial[dossierId].attributes as Testimonial;
}
